<template>
  <v-dialog v-model="mostrado" :max-width="maxWidth" persistent>
    <v-card>
      <v-card-title class="py-2 px-4">{{ titulo }}</v-card-title>

      <v-divider class="my-0"></v-divider>

      <v-card-text class="pa-4">
        <p v-html="mensaje"></p>

        <slot></slot>
      </v-card-text>

      <v-divider class="my-0"></v-divider>

      <v-card-actions>
        <v-btn color="blue darken-1" text @click.prevent="cerrar" :disabled="realizandoAccion"> Cancelar </v-btn>

        <v-btn
          color="blue darken-1"
          text
          @click.prevent="aceptar"
          :disabled="realizandoAccion"
          :loading="realizandoAccion">
          Aceptar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'ConfirmacionAccion',
  props: {
    titulo: {
      type: String,
      default: '',
    },
    mensaje: {
      type: String,
      default: '',
    },
    realizandoAccion: {
      type: Boolean,
      default: false,
    },
    maxWidth: {
      type: [String, Number],
      default: 500,
    },
  },
  data() {
    return {
      mostrado: false,
    };
  },
  methods: {
    abrir() {
      this.mostrado = true;
    },
    cerrar() {
      this.mostrado = false;

      this.$emit('cerrar');
    },
    aceptar() {
      this.$emit('aceptar');
    },
  },
};
</script>